export function checkData(val){
    return (val !== undefined && val !== null && val !== '' && Object.entries(val).length >0 ) ? true : false; 
}
export function checkArrayData(val){
    return val.length > 0 ? true : false; 
}
export function checkUndeNullBlank(val){
    return (val !== undefined && val !== null && val !== '') ? true : false; 
}